<template>
  <div>Redirecting...</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OidcAuthenticate",
  methods: {
    ...mapActions("brain/auth", ["oidcSigninRedirectCallback", "setOidcUser"]),
  },
  mounted() {
    // oidc-client-ts does NOT like our #, so we get rid of it before parsing
    let newLocation = window.location.href.split("#")[1];
    window.history.replaceState({}, null, newLocation);

    this.oidcSigninRedirectCallback()
      .then((user) => {
        this.setOidcUser(user);
        window.history.replaceState({}, null, "/#/");
        this.$router.push({ name: "advanced" });
      })
      .catch((error) => {
        console.error("oidcSigninRedirectCallback error:", error);
      });
  },
};
</script>
